import { randomFromRange, roundDecimalPlaces } from './utils.js'


class HslColor {

    constructor(hue, sat, light, alpha) {
        this.hue = roundDecimalPlaces(hue, 1)
        this.sat = roundDecimalPlaces(sat, 1)
        this.light = roundDecimalPlaces(light, 1)
        this.alpha = roundDecimalPlaces(alpha, 3)
    }

    changeHue(chg) {
        this.hue += chg
        return this
    }

    changeSaturation(chg) {
        this.sat += chg
        return this
    }

    changeLightness(chg) {
        this.light += chg
        return this
    }

    changeAlpha(chg) {
        this.alpha += chg
        return this
    }

    getHue() {
        return this.hue
    }

    getSaturation() {
        return this.sat
    }

    getLightness() {
        return this.light
    }

    getAlpha() {
        return this.alpha
    }

    getString() {
        return `hsl(${this.hue}, ${this.sat}%, ${this.light}%, ${this.alpha})`
    }
}

class HslVary {
    constructor(hueVary, satVary, lightVary, alphaVary) {
        this.hueVary = hueVary
        this.satVary = satVary
        this.lightVary = lightVary
        this.alphaVary = alphaVary
    }

    modulateVary(factor) {
        this.hueVary *= factor
        this.satVary *= factor 
        this.lightVary *= factor
        this.alphaVary *= factor
        return this
    }

    getHueVary() {
        return this.hueVary
    }

    getSatVary() {
        return this.satVary
    }

    getLightVary() {
        return this.lightVary
    }

    getAlphaVary() {
        return this.alphaVary
    }
}


const randHsl = function(hueRange=[0, 360], satRange=[0, 100], lightRange=[0, 100], alphaRange=[0, 1]) {
    let hue = randomFromRange(...hueRange)
    let sat = randomFromRange(...satRange)
    let light = randomFromRange(...lightRange)
    let alpha = randomFromRange(...alphaRange)
    return new HslColor(hue, sat, light, alpha)
}


const randHslVary = function(hueRange=[0.2, 0.4], satRange=[0.1, 0.2], lightRange=[0.1, 0.4], alphaRange=[0.05, 0.15]) {
    let hue = randomFromRange(...hueRange)
    let sat = randomFromRange(...satRange)
    let light = randomFromRange(...lightRange)
    let alpha = randomFromRange(...alphaRange)
    return new HslVary(hue, sat, light, alpha)
}


export { HslColor, HslVary, randHsl, randHslVary }
